export default __webpack_public_path__ + "static/media/AURA_symbol.5c0bb45b.png";